import { render, staticRenderFns } from "./ResultsTilesMultiple.vue?vue&type=template&id=22a74268&"
import script from "./ResultsTilesMultiple.vue?vue&type=script&lang=js&"
export * from "./ResultsTilesMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports